'use strict';
const angular = require('angular');

export class datePickerComponent {
  dateOptions = {
    minDate: new Date(),
    format: 'shortDate'
  };
  popup = {};
  format = 'shortDate';

  /*@ngInject*/
  constructor() {
    this.message = 'World';
    // this.date = this.date || new Date();
    this.inputName = 'test';
    this.inputRequired = false;
    this.inputDisabled = false;
    this.dateOptions.minDate = this.minDate || null;
  }

  clear() {
    this.dt = null;
  }

  open() {
    this.dateOptions.minDate = this.minDate || null;
    this.popup.opened = true;
    console.log(this.inputDisabled);
  }

}

export default angular.module('fiapiApp.datePicker', [])
  .component('datePicker', {
    template: require('./datePicker.pug'),
    bindings: { dt: '=', change: '=', minDate: '<', inputSize: '@', inputRequired: '@', inputDisabled: '@', inputName: '@' },
    controller: datePickerComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/datePicker/datePicker.component.js